/*
 * 勝者の選択は画面下端のシートとして出す。
 *
 * `position: fixed` にはしない。固定すると運営操作のパネルを覆い、画面の高さによって
 * 「直前の操作を取り消す」に到達できなくなる。DisplayApp の shell が表示領域と同じ高さに
 * 固定されているため、通常のフローに置いても卓が縮むだけでページは伸びない。
 *
 * モーダルにもしない（オーバーレイを敷かない）。勝者を決めている間もスタックとポット総額は
 * 見えている必要があり、暗転させると卓上の確認ができなくなる。
 */

.sheet {
  flex: none;
  /* ポットが多いときはシート内でスクロールする。卓を潰しきらない高さに抑える。 */
  max-height: 45vh;
  overflow-y: auto;
  padding: var(--mantine-spacing-md);
  background: var(--mantine-color-dark-8);
  /* プレイヤー端末の「あなたの番」と同じ、黄色の縁で注意を促す作りに揃える。 */
  border-top: 0.25rem solid var(--mantine-color-yellow-4);
  box-shadow: 0 -0.75rem 2rem rgb(0 0 0 / 55%);
  animation: rise 180ms ease-out;
}

@keyframes rise {
  from {
    transform: translateY(35%);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .sheet {
    animation: none;
  }
}
